import { css } from '@emotion/core';
import { tokens, media } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var followedProperty = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";");
export var text = /*#__PURE__*/css(designTokenFonts.body, " margin-top:16px;margin-bottom:8px;");
export var link = /*#__PURE__*/css("color:", colors.interactive.base.default, ";text-decoration:none;");
export var button = /*#__PURE__*/css("width:345px;", media('<tablet'), "{width:100%;}");
export var buttonText = {
  name: "1isemmb",
  styles: "margin-left:8px;"
};